/* Kkumi password page - launch countdown, password reveal and the empty-field
   guard for sections/kkumi-password-protected.liquid.

   Everything here is driven by data-attributes on the section root so this
   file carries no Liquid and no user-facing copy of its own (FRONTEND.md).
   The waitlist form is a separate concern and lives in
   assets/section-kkumi-password-waitlist.js.

   The countdown target arrives as a full ISO 8601 string with an explicit UTC
   offset, e.g. 2026-10-14T00:00:00+08:00, built in Liquid from the merchant's
   date / time / offset settings. The explicit offset is what makes the
   countdown read the same number of seconds for a visitor in Perth and one in
   London. A target that will not parse simply leaves the tiles at their
   server-rendered values instead of showing NaN. */
(function () {
  function pad(n) {
    return String(n).padStart(2, '0');
  }

  /* Solo mode (hero switched off) centres the card in the viewport with a
     min-height, which has to discount whatever sits above the section. */
  function trackOffset(sectionEl, root) {
    function sync() {
      var topPx = sectionEl.getBoundingClientRect().top + window.scrollY;
      root.style.setProperty('--kk-pwp-offset', topPx + 'px');
    }
    sync();
    window.addEventListener('resize', sync, { passive: true });
    window.addEventListener('load', sync, { once: true });
  }

  function initCountdown(root) {
    var cd = root.querySelector('[data-kk-countdown]');
    if (!cd) return;

    var target = Date.parse(root.dataset.launchIso || '');
    if (!Number.isFinite(target)) return;

    var cells = {
      days: cd.querySelector('[data-cd="days"]'),
      hours: cd.querySelector('[data-cd="hours"]'),
      minutes: cd.querySelector('[data-cd="minutes"]'),
      seconds: cd.querySelector('[data-cd="seconds"]')
    };
    var note = root.querySelector('[data-kk-cd-note]');
    var liveNote = root.dataset.noteLive || '';
    var timer = null;

    function paint(d, h, m, s) {
      if (cells.days) cells.days.textContent = pad(d);
      if (cells.hours) cells.hours.textContent = pad(h);
      if (cells.minutes) cells.minutes.textContent = pad(m);
      if (cells.seconds) cells.seconds.textContent = pad(s);
    }

    function tick() {
      var diff = target - Date.now();
      if (diff <= 0) {
        paint(0, 0, 0, 0);
        cd.dataset.state = 'live';
        /* Guarded because this also runs on the first paint of an already
           passed launch: writing identical text on every tick would be a
           pointless DOM write, and the interval is cleared either way. */
        if (note && liveNote && note.textContent !== liveNote) note.textContent = liveNote;
        if (timer) {
          clearInterval(timer);
          timer = null;
        }
        return;
      }
      var secs = Math.floor(diff / 1000);
      paint(
        Math.floor(secs / 86400),
        Math.floor((secs % 86400) / 3600),
        Math.floor((secs % 3600) / 60),
        secs % 60
      );
    }

    tick();
    if (timer === null && Date.now() < target) timer = setInterval(tick, 1000);
  }

  function initPassword(root) {
    var card = root.querySelector('[data-kk-pw-card]');
    /* Bound on the <form> itself, not a wrapper inside it: a submit event
       fires on the form and bubbles UP, so a descendant never sees it. */
    var form = root.querySelector('.kk-pwp__form');
    var input = root.querySelector('[data-kk-pw-input]');
    var toggle = root.querySelector('[data-kk-pw-toggle]');
    var msg = root.querySelector('[data-kk-pw-msg]');

    if (toggle && input) {
      toggle.addEventListener('click', function () {
        var reveal = input.type === 'password';
        input.type = reveal ? 'text' : 'password';
        toggle.classList.toggle('is-revealed', reveal);
        toggle.setAttribute('aria-pressed', reveal ? 'true' : 'false');
        var label = reveal ? toggle.dataset.hideLabel : toggle.dataset.showLabel;
        if (label) toggle.setAttribute('aria-label', label);
        input.focus();
        // Keep the caret at the end rather than selecting the whole value.
        try { input.setSelectionRange(input.value.length, input.value.length); } catch (_) {}
      });
    }

    /* Empty submit never reaches Shopify: an empty password just reloads the
       page with no error, which reads as the page ignoring the visitor. Catch
       it here and reuse the same shake the wrong-password state uses. */
    var emptyMessage = root.dataset.emptyMessage || '';
    if (!form || !input || !card) return;
    form.addEventListener('submit', function (e) {
      if (input.value.trim()) return;
      e.preventDefault();
      card.classList.remove('is-error');
      void card.offsetWidth; // force reflow so a repeat submit re-runs the shake
      card.classList.add('is-error');
      if (msg) {
        msg.classList.remove('ok');
        msg.textContent = emptyMessage;
      }
      input.focus();
    });
  }

  function init() {
    document.querySelectorAll('[data-kk-pwp]').forEach(function (root) {
      if (root.dataset.kkBound) return;
      root.dataset.kkBound = '1';

      var sectionEl = root.closest('.shopify-section') || root.parentElement;
      if (sectionEl && root.dataset.layout === 'solo') trackOffset(sectionEl, root);

      initCountdown(root);
      initPassword(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
